import classNames from 'classnames';
import Iconify from 'src/components/iconify';
import { CustomActionButton } from './styles';

type Props = {
  tooltip: string;
  isFromNav?: boolean;
};

export const CoperaAiButtonDisabled = ({ tooltip, isFromNav }: Props) => (
  <CustomActionButton
    color="inherit"
    disabled
    tooltip={tooltip}
    className={classNames({ isFromNav })}
  >
    <Iconify icon="copera:logo" />
  </CustomActionButton>
);
